function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2601 13.0218C17.2601 13.4898 16.8803 13.8696 16.4123 13.8696C15.9443 13.8696 15.5645 13.4898 15.5645 13.0218C15.5645 12.5538 15.9443 12.174 16.4123 12.174C16.8803 12.174 17.2601 12.5538 17.2601 13.0218V13.0218Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2609 21.5L16.8624 19.9061C16.6971 19.2456 16.2062 18.7157 15.561 18.5004L12.6165 17.5186C11.6211 17.104 11.2888 15.5076 11.2888 15.1964C11.7661 14.8022 12.2841 14.1188 12.2841 13.5381C12.2841 12.9573 12.6165 12.8742 12.6165 12.8742C12.6165 12.8742 12.948 12.045 12.948 11.5474C12.948 11.5474 12.8649 11.2159 12.6165 11.2159V9.22518C12.6165 7.59396 11.7873 7.73216 11.9526 7.56598C11.9526 7.17937 11.4829 6.23914 9.63044 6.23914C7.74402 6.23914 6.64439 8.03653 6.64439 9.22518V11.2159C6.39598 11.2159 6.31289 11.5474 6.31289 11.5474C6.31289 12.045 6.64439 12.8742 6.64439 12.8742C6.64439 12.8742 6.97674 12.9573 6.97674 13.5381C6.97674 14.1188 7.49476 14.8022 7.97209 15.1964C7.97209 15.5076 7.63974 17.104 6.64439 17.5186L3.69989 18.5004C3.0547 18.7157 2.5638 19.2456 2.39848 19.9061L2 21.5",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8699 10.4783H17.2612C19.602 10.4783 21.5003 8.57998 21.5003 6.23913C21.5003 3.89828 19.602 2 17.2612 2C15.563 2 14.1081 3.00552 13.4324 4.44767C12.8516 3.98391 12.1267 3.69565 11.3264 3.69565C10.0716 3.69565 8.97537 4.3773 8.38867 5.3913",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.381 7.087C19.381 7.321 19.1911 7.51091 18.9571 7.51091C18.7231 7.51091 18.5332 7.321 18.5332 7.087C18.5332 6.853 18.7231 6.66309 18.9571 6.66309C19.1911 6.66309 19.381 6.853 19.381 7.087",
  fill: "#627D98"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.2931 7.087C14.2931 7.321 14.1032 7.51091 13.8692 7.51091C13.6352 7.51091 13.4453 7.321 13.4453 7.087C13.4453 6.853 13.6352 6.66309 13.8692 6.66309C14.1032 6.66309 14.2931 6.853 14.2931 7.087",
  fill: "#627D98"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.8361 7.087C16.8361 7.321 16.6462 7.51091 16.4122 7.51091C16.1782 7.51091 15.9883 7.321 15.9883 7.087C15.9883 6.853 16.1782 6.66309 16.4122 6.66309C16.6462 6.66309 16.8361 6.853 16.8361 7.087",
  fill: "#627D98"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.717 15.1413C14.717 15.3753 14.5271 15.5652 14.2931 15.5652C14.0591 15.5652 13.8691 15.3753 13.8691 15.1413C13.8691 14.9073 14.0591 14.7174 14.2931 14.7174C14.5271 14.7174 14.717 14.9073 14.717 15.1413V15.1413Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcoReceptionist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoReceptionist);
export default __webpack_public_path__ + "static/media/ico-receptionist.8d23506b.svg";
export { ForwardRef as ReactComponent };